import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QrCodeService } from 'src/app/services/qr-code/qr-code.service';

@Component({
  selector: 'app-qr-code-location-modal',
  templateUrl: './qr-code-location-modal.component.html',
})
export class QrCodeLocationModalComponent implements OnInit {
  @Input() id: number;
  @Input() isPreview: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private service: QrCodeService
  ) {}

  ngOnInit(): void {}

  confirm() {
    this.activeModal.close();
    this.getGeoLocationData();
  }

  private async getGeoLocationData() {
    if ('geolocation' in navigator) {
      try {
        const position = await new Promise<any>((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        const { latitude, longitude } = position.coords;

        this.service.notify(this.id, latitude, longitude);
      } catch (error) {
        this.service.notify(this.id, 0, 0);
        console.error('Geolocation is disabled');
      }
    } else {
      this.service.notify(this.id, 0, 0);
      console.log('Geolocation is not supported by this browser.');
    }
  }
}
